import { Outlet } from "react-router";

import SubSidebar from "components/SubSidebar";
import SubSidebarSection from "components/SubSidebar/Section";
import SubSidebarSectionItem from "components/SubSidebar/SectionItem";
import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import Box from "ds/components/Box";

const ScanSettingsRoutesLayout = () => {
  return (
    <>
      <ViewHeader>
        <ViewHeaderWrapper>
          <ViewHeaderTitle>Scan settings</ViewHeaderTitle>
        </ViewHeaderWrapper>
      </ViewHeader>

      <Box grow="1" zeroMinHeight>
        <SubSidebar>
          <SubSidebarSection>
            <SubSidebarSectionItem to=".." end>
              Scan details
            </SubSidebarSectionItem>
            <SubSidebarSectionItem to="../cloud-provider">Cloud provider</SubSidebarSectionItem>
            <SubSidebarSectionItem to="../worker-pool">Worker pool</SubSidebarSectionItem>
            <SubSidebarSectionItem to="../resource-scope">Scope of resources</SubSidebarSectionItem>
          </SubSidebarSection>
        </SubSidebar>

        <Box direction="column" surfaceColor="primary" grow="1" zeroMinHeight>
          <Outlet />
        </Box>
      </Box>
    </>
  );
};

export default ScanSettingsRoutesLayout;
